module.exports = __webpack_public_path__ + "static/media/YM46_4.f40456ff.jpg";